window.astWpMenuClassChange = function (path) {
	const pageSlug = astra_admin.home_slug;
	const pathMap = {
		"custom-layouts": "custom-layouts",
		spectra: "spectra",
		woocommerce: "woocommerce",
	};

	const queryPath = pathMap[path] ? `&path=${pathMap[path]}` : "";
	const pageUrl = `admin.php?page=${pageSlug}${queryPath}`;

	const bodyClasses = {
		settings: "ast-admin-settings-page",
		woocommerce: "ast-admin-extensions-page",
		"starter-templates": "ast-admin-starter-page",
	};

	// Remove all possible classes.
	document.body.classList.remove(...Object.values(bodyClasses));

	// Add the appropriate class if it exists in the map.
	if (bodyClasses[path]) {
		document.body.classList.add(bodyClasses[path]);
	}

	// Remove 'current' class from all items.
	document
		.querySelectorAll(".wp-submenu .current")
		.forEach((item) => item.classList.remove("current"));

	// Add 'current' class to matching items.
	document
		.querySelectorAll(`.wp-submenu-wrap li > a[href$="${pageUrl}"]`)
		.forEach((item) => item.parentElement.classList.add("current"));
};
